__turbopack_context__.v({
  "hasAdvisor": "styles-module-scss-module__jzSV8G__hasAdvisor",
  "hasAdvisor__card": "styles-module-scss-module__jzSV8G__hasAdvisor__card",
  "hasAdvisor__card__modActive": "styles-module-scss-module__jzSV8G__hasAdvisor__card__modActive",
});
